export default __webpack_public_path__ + "static/media/globalSearchIcon.b98db2e8.png";